import React from 'react';
import styled from 'styled-components';
import { HORIZONTAL_PADDING } from './constants';

type ContainerProps = {
  children: React.ReactNode;
  className?: string;
};

const StyledContainer = styled.div`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 ${HORIZONTAL_PADDING};
`;

export const Container: React.FC<ContainerProps> = ({ children, className }) => {
  return <StyledContainer className={className}>{children}</StyledContainer>;
};
